import { AfterViewInit, Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Login } from 'src/app/model/request/auth';
import { LoginFailedResponse, LoginResponse } from 'src/app/model/response/auth-r';
import { BrowserDetectorService } from 'src/app/services/browser-detector.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { AppState } from 'src/app/store/root.state';
import { DialogUtility } from '@syncfusion/ej2-angular-popups';
import { LoginService } from '../login.service';
import { AuthService } from 'src/app/services/auth.service';
import * as userActions from 'src/app/store/user/user.actions';
import * as moduleActions from 'src/app/store/modules/modules.actions';
import * as menuActions from 'src/app/store/session/menu/menu.actions'
import { Subject, filter, interval, map, switchMap, take, takeUntil, takeWhile, timer } from 'rxjs';
import { CryptHelperService } from 'src/app/services/helpers/crypt-helper.service';
import { DateTime } from '@syncfusion/ej2-angular-charts';
import { ModuleBaseResponse } from 'src/app/model/response/modules/modules-menu';
import { SideBarService } from '../../sidebar/sidebar.service';
import { environment } from 'src/environments/environment';
import { trigger, transition, style, animate } from '@angular/animations';
import { MSAL_GUARD_CONFIG, MsalBroadcastConfiguration, MsalBroadcastService, MsalGuardConfiguration, MsalService } from '@azure/msal-angular';
import { AuthenticationResult, EventMessage, EventType, InteractionStatus, PopupRequest } from '@azure/msal-browser';
import { MicrosoftAuthLoginRequest, MicrosoftSuccessLoginresponse } from 'src/app/model/microsoft-auth/microsoft-auth';
import { MicrosoftAuthService } from 'src/app/services/microsoft.service';

@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss', '../login.component.scss'],
  animations: [
    trigger('slideDownUp', [
      transition(':enter', [
        style({ overflow: 'hidden', opacity: 0 }),
        animate('300ms cubic-bezier(0.25, 0.1, 0.25, 1)', style({ overflow: 'hidden', opacity: 1 })),
      ]),
      transition(':leave', [
        style({ overflow: 'hidden', opacity: 1 }),
        animate('330ms cubic-bezier(0.25, 0.1, 0.25, 1)', style({ overflow: 'hidden', opacity: 0 })),
      ]),
    ]),
  ]
  //providers: [{ provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.recaptcha.siteKey },ReCaptchaV3Service],
})
export class LoginFormComponent implements OnInit, AfterViewInit, OnDestroy {

  // create strict typed angular form, preaty neat
  formLogin = new FormGroup({
    username: new FormControl<string>('', [
      Validators.required,
      Validators.maxLength(100),
      Validators.minLength(1),
    ]),
    password: new FormControl<string>('', [
      Validators.required,
      Validators.minLength(1),
    ]),
  });

  decryped: string = '';
  parsed: number[] = [];

  formHaveErrors: boolean = false;
  passwIcon: string = 'e-icons cursor-pointer spass';
  errMsg: string = '';

  alreadyLoged = false;

  rispLogin: LoginResponse;

  // pop up disconect
  public dialog: any;
  execLogout: boolean = false;

  logoSpinner: string = `${environment.baseHREF}${environment.logo}`;

  // unsubscribe subscription
  private theEnd$ = new Subject<void>();

  secondsRemaining$: any;

  token: string = '';

  testTimer: string = '';
  showTimer: boolean = false;

  isIframe = false;
  loginDisplay = false;

  microsoftUrl: string = environment.logoMicrosoft;
  logoChange: boolean = false;
  microsoftError: boolean = false;

  showRegisteredMessagge: boolean = false;


  /*
  public executeImportantAction(): void {
    this.recaptchaV3Service.execute('importantAction').pipe(takeUntil(this.theEnd$))
      .subscribe({
        next:(response:any)=>{
          console.log("RECAPTCHA RESPONSE : "+response)
          console.log("LOGGING IN....")
          this.login();
        },
        error:(response:any)=>{
          console.log("RECAPTCHA ERROR RESPONSE : "+response)
        }
      });
  }*/


  public addTokenLog(message: string, token: string | null) {
    console.log(`${message}: ${token}`);
    this.token = token || '';
  }


  constructor(
    private loginService: LoginService,
    private router: Router,
    private route: ActivatedRoute,
    private localStorageService: LocalStorageService,
    private browserDetector: BrowserDetectorService,
    private authService: AuthService,
    private sidebarService: SideBarService,
    private store: Store<AppState>,
    private crypter: CryptHelperService,
    // for microsoft login
    private MsalService: MsalService,
    private MsalBroadcastService: MsalBroadcastService,
    private MicrosoftService: MicrosoftAuthService,
    //@Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    //private recaptchaV3Service: ReCaptchaV3Service,
  ) {
    this.passwIcon += ' e-eye';
    this.rispLogin = {
      response: {
        severity: "",
        success: true,
        error: "",
        errorCode: ""
      },
      user: {
        userId: 0,
        username: "",
        password: "",
        surname: "",
        email: "",
        name: "",
        roles: [],
        rolesId: [],
        filiali: [],
        creationDate: "",
        active: false,
        authorized: false,
      },
      token: "",
      refreshToken: "",
      authorized: false,
      roles: [],
      rolesId: [],
    }
  }
  ngAfterViewInit(): void {
    let refresh = localStorage.getItem('refresh');
    if (refresh) {
      location.reload();
      localStorage.removeItem('refresh')
    }

    setTimeout(() => {
      // get url parameters
      let kickedOut: string | null;
      let expiredToken: string | null;
      kickedOut = this.route.snapshot.paramMap.get('newConn');

      expiredToken = this.route.snapshot.params['tokenExpired'];
      console.warn(kickedOut);

      if (kickedOut != null) {
        this.errMsg = "Disconesso, qualcuno ha eseguito l'accesso con questo account su un'altra macchina!";
        this.formHaveErrors = true;
      }

      if (expiredToken != null) {
        this.errMsg = "La sessione è scaduta, effettua il login per continuare";
        this.formHaveErrors = true;
      }
    }, 0)



    console.log(refresh);
    this.localStorageService.addValue("SomeCrazyShit", "WOW");
  }


  ngOnInit(): void {
    // chek if user is already logged in
    if (this.localStorageService.isLogedIn()) {
      // ****************************************************** TO DO ottenere l'ultima page visitata e reinderizzare l'utente *************************************************
      //this.router.navigate(['/home']);
      console.log("Session not null");
    }


    this.loginService.loginSubject.pipe(takeUntil(this.theEnd$)).subscribe({
      next: (val: boolean) => {
        if (val == true) {
          this.okPopClick();
        }
      }
    })


    this.MsalService.initialize().pipe(takeUntil(this.theEnd$)).subscribe({
      next: (data: any) => {
        console.warn("MS INITIATED");
        console.warn(data);
      }
    });

    this.MsalBroadcastService.msalSubject$.pipe(
      filter((msg: EventMessage) => msg.eventType === EventType.ACCOUNT_ADDED || msg.eventType === EventType.ACCOUNT_REMOVED),
      takeUntil(this.theEnd$),
    )
      .subscribe({
        next: (msg: EventMessage) => {
          console.warn("msalbroadcastService");
          console.warn(msg);
          if (this.MsalService.instance.getAllAccounts().length === 0) {
            window.location.pathname = "api://c9c0dccb-5287-40c4-bf50-dd05b0811fdf/Forecast.Read";
          } else {
            //this.setLoginDisplay();
          }
        }
      });

    this.MsalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        takeUntil(this.theEnd$)
      )
      .subscribe((res: any) => {
        console.warn("MSALSEVRICE IN PROGERES");
        console.warn(res);
        //this.setLoginDisplay();
        //this.checkAndSetActiveAccount();
      });

  }

  ngOnDestroy(): void {
    this.theEnd$.unsubscribe();
  }

  showPassword() {
    const pwdI = document.getElementById('pwdInput');
    if (this.passwIcon.includes('-slash')) {
      this.passwIcon = this.passwIcon.replace('-slash', '');
      pwdI?.setAttribute('type', 'password');
      console.log('removed slash');
    } else {
      this.passwIcon += '-slash';
      pwdI?.setAttribute('type', 'text');
      console.log('added slash');
    }
  }

  login() {
    this.execLogout = true;
    this.rispLogin.response.success = true;
    if (this.formLogin.invalid) {
      this.errMsg = 'I campi username e password sono obbligatori';
      this.formHaveErrors = true;
      console.error(
        'Errors in form validation, check the inserted data and try again'
      );
      this.execLogout = false;
      return;
    }

    console.log('Starting user login');



    let loginData: Login = {
      username: this.formLogin.value.username || '',
      password: this.formLogin.value.password || '',
    };


    if (loginData.username == '' || loginData.password == '') {
      this.errMsg =
        'Perfavore compila i campi username e passowrd prima di procedere';
      this.formHaveErrors = true;
      this.execLogout = false;
      return;
    }

    //crypt pwd
    loginData.password = this.crypter.encryptString(loginData.password);
    console.warn("PWD crypted");
    console.warn("Here it is: ");
    console.warn(loginData.password);
    // OLD
    // loginUser
    this.loginService.LoginCryptedPwd(loginData).pipe(takeUntil(this.theEnd$)).subscribe({
      next: (risp: LoginResponse) => {
        console.log(risp);

        if (risp.response.success == true) {
          this.localStorageService.saveSession(risp);
          this.store.dispatch(new userActions.Login({
            userId: risp.user.userId,
            username: risp.user.username,
            roles: risp.user.roles,
            rolesId: risp.user.rolesId,
            filiali: risp.user.filiali,
            password: risp.user.password,
            creationDate: risp.user.creationDate,
            email: risp.user.email,
            surname: risp.user.surname,
            active: risp.user.active,
            authorized: risp.user.authorized,
            checking: false,
            neverLogged: false,

          }))

          this.sidebarService.getAllModules(risp.user.userId || 0).pipe(takeUntil(this.theEnd$)).subscribe({
            next: (value: ModuleBaseResponse) => {
              localStorage.setItem('M', this.localStorageService.encrypt(JSON.stringify(value.menu)))
              this.localStorageService.menuReady$.next(true);
            }
          })
          this.execLogout = false;
          //ENABLE WHEN BETTER SERVER NOT SHIT DUALCORE
          //this.authService.fetchData.emit("LOGIN")
          this.router.navigate(['/home/dashboard']);

        } else if (risp.response.errorCode === "ULOGED0010") {
          console.log("\n user loged damn \n");
          this.alreadyLoged = true;
          this.execLogout = false;
          /* this.dialog = DialogUtility.confirm({
            title: 'Login già eseguito su un\'altra macchina',
            content: 'Clicca Ok per eseguire il logout dall\'altra macchina ed accedere qui',
            width: '100vh',
            position: { X: 'center', Y: 'center' },
            okButton: { click: this.okPopClick.bind(this) },
            cancelButton: { click: this.cancelPopClick.bind(this) },
          }); */

          setTimeout(() => {
            document.getElementById("confirm-login-button")?.focus();
          }, 100);



        } else {
          this.execLogout = false;
          this.rispLogin = risp;
        }
      },
      error: (response: any) => {
        if ('response' in response) {
          if (response.response.errorCode == 'TMLOAT0012') {
            console.log('DSFFBghjsgsdhvdhgfdsiy')
            this.showTimer = true;
            this.testTimer = response.lastLogin || 'NON FUNONZIA';
            this.formHaveErrors = true;
            this.errMsg = response.response.error;
            this.secondsRemaining$ = timer(0, 1000).pipe(
              map(date => new Date(response.lastLogin || '').getTime()),
              switchMap(date => interval(1000).pipe(map(() => date - Date.now())))
            );

          }

          if (response.response.errorCode === "ULOGED0010") {
            console.log("\n user loged damn \n");
            this.alreadyLoged = true;
            this.execLogout = false;
            /* this.dialog = DialogUtility.confirm({
              title: 'Login già eseguito su un\'altra macchina',
              content: 'Clicca Ok per eseguire il logout dall\'altra macchina ed accedere qui',
              width: '100vh',
              position: { X: 'center', Y: 'center' },
              okButton: { click: this.okPopClick.bind(this) },
              cancelButton: { click: this.cancelPopClick.bind(this) },
            }); */
            setTimeout(() => {
              document.getElementById("confirm-login-button")?.focus();
            }, 100);
          }

          if (response.response.errorCode != "ULOGED0010") {
            this.formHaveErrors = true;
            this.errMsg = response.response.error;
          }
        } else {
          this.formHaveErrors = true;
          this.errMsg = "Errore durante il login, server spento o irrangiungibile. Riprova più tardi";
        }
        console.error('Error while registering');
        console.error(response);
        this.execLogout = false;
      },
    });
  }

  okPopClick(): void {
    this.execLogout = false;
    this.execLogout = true;
    //this.dialog.hide();    
    //this.dialog.hide();
    //this.loginService.logOut().subscribe;
    let session = this.localStorageService.getSession();
    /*if(session == null) {
      console.log('user already logged out');
      this.router.navigate(['/auth/login']);
      return;
    }*/
    this.loginService.logOut(0, this.formLogin.value.username || "user", true).pipe(takeUntil(this.theEnd$)).subscribe({
      next: (d: any) => {
        this.localStorageService.clearSession();
        console.log('log out completed, doing login next...');
        let loginData: Login = {
          username: this.formLogin.value.username || '',
          password: this.formLogin.value.password || '',
        };

        //crypt pwd
        loginData.password = this.crypter.encryptString(loginData.password);
        console.warn("PWD crypted");
        console.log(loginData);

        // old
        // this.loginService.loginUser
        this.loginService.LoginCryptedPwd(loginData).pipe(takeUntil(this.theEnd$)).subscribe({
          next: (risp: LoginResponse) => {
            console.log(risp);

            if (risp.response.success == true) {
              this.localStorageService.saveSession(risp);
              this.store.dispatch(new userActions.Login({
                userId: risp.user.userId,
                username: risp.user.username,
                roles: risp.user.roles,
                rolesId: risp.user.rolesId,
                filiali: risp.user.filiali,
                password: risp.user.password,
                creationDate: risp.user.creationDate,
                email: risp.user.email,
                surname: risp.user.surname,
                active: risp.user.active,
                authorized: risp.user.authorized,
                checking: false,
                neverLogged: false,
              }));

              this.sidebarService.getAllModules(risp.user.userId || 0).pipe(takeUntil(this.theEnd$)).subscribe({
                next: (value: ModuleBaseResponse) => {
                  localStorage.setItem('M', this.localStorageService.encrypt(JSON.stringify(value.menu)));
                  this.localStorageService.menuReady$.next(true);
                }
              })

              this.execLogout = false;
              //this.dialog.hide();
              //this.authService.fetchData.emit("LOGIN")
              this.router.navigate(['/home/dashboard']);
            } else {
              this.execLogout = false;
              this.rispLogin = risp;
              //this.dialog.hide();
            }

          },
          error: (response: LoginResponse) => {
            this.execLogout = false;
            console.error('Error while loging in');
            console.error(response.response.error);
            //this.dialog.hide();
          }
        });
        //this.router.navigate(['/auth/login']);
      },
      error: (e: any) => {
        this.execLogout = false;
        this.localStorageService.clearSession();
        console.log('Partial logout executed');
        this.rispLogin = {
          response: {
            success: false,
            error: "Impossibile eseguire il logout, errore di connessione con il database",
            severity: 'error',
            errorCode: 'DBQERR0002'
          },
          user: {
            userId: 0,
            username: "",
            email: "",
            surname: "",
            password: "",
            creationDate: "",
            roles: [],
            rolesId: [],
            filiali: [],
            active: false,
            authorized: false,
          },
          token: "",
          refreshToken: "",
          authorized: false,
          roles: [],
          rolesId: [],
        }
        //this.router.navigate(['/auth/login']);
        this.dialog.hide();
      }
    });

  }

  cancelPopClick(): void {
    location.reload();
    this.execLogout = false;
    //this.dialog.hide();
  }

  loginM() {



    /*this.MsalService.loginPopup()
    .subscribe({
      next: (res: any) => {
        console.warn("\n \n THIS IS THE RES FROM MICSOF \n \n ");
        console.warn(res);
      },
      error: (res: any) => {
        console.error("\n \n GODAMN MICSOF LOGIN DID NOT WORK \n \n");
        console.error(res);
      }
    });*/
  }

  setLoginDisplay() {
    this.loginDisplay = this.MsalService.instance.getAllAccounts().length > 0;
  }

  checkAndSetActiveAccount() {
    /**
     * If no active account set but there are accounts signed in, sets first account to active account
     * To use active account set here, subscribe to inProgress$ first in your component
     * Note: Basic usage demonstrated. Your app may require more complicated account selection logic
     */
    let activeAccount = this.MsalService.instance.getActiveAccount();

    if (!activeAccount && this.MsalService.instance.getAllAccounts().length > 0) {
      let accounts = this.MsalService.instance.getAllAccounts();
      this.MsalService.instance.setActiveAccount(accounts[0]);
    }
  }

  loginPopup() {
    this.execLogout = true;
    this.microsoftError = false;
    this.MsalService.loginPopup()
      .pipe(takeUntil(this.theEnd$))
      .subscribe({
        next: (response: AuthenticationResult) => {
          this.MsalService.instance.setActiveAccount(response.account);
          console.warn("LOGIN DONE");
          console.warn(response);

          let loginReq: MicrosoftAuthLoginRequest = {
            email: response.account.username,
            token: response.idToken,
            username: response.account.name ?? '',
            homeAccountId: response.account.homeAccountId,
            localAccountId: response.account.localAccountId,
          };

          console.warn("THIS IS REQUEST");
          console.warn(loginReq);


          this.MicrosoftService.loginMicrosoft(loginReq).pipe(takeUntil(this.theEnd$)).subscribe({
            next: (risp: LoginResponse) => {

              if (risp.response.success == true) {

                // if the user does not have any role dotn redirect him
                if (risp.user.roles.length == 0) {
                  this.showRegisteredMessagge = true;


                } else {

                  this.localStorageService.saveSession(risp);
                  this.store.dispatch(new userActions.Login({
                    userId: risp.user.userId,
                    username: risp.user.username,
                    roles: risp.user.roles,
                    rolesId: risp.user.rolesId,
                    filiali: risp.user.filiali,
                    password: risp.user.password,
                    creationDate: risp.user.creationDate,
                    email: risp.user.email,
                    surname: risp.user.surname,
                    active: risp.user.active,
                    authorized: risp.user.authorized,
                    checking: false,
                    neverLogged: false,
                  }));

                  this.sidebarService.getAllModules(risp.user.userId || 0).pipe(takeUntil(this.theEnd$)).subscribe({
                    next: (value: ModuleBaseResponse) => {
                      localStorage.setItem('M', this.localStorageService.encrypt(JSON.stringify(value.menu)));
                      this.localStorageService.menuReady$.next(true);
                    }
                  })

                  this.execLogout = false;
                  //this.dialog.hide();
                  //this.authService.fetchData.emit("LOGIN")

                  this.router.navigate(['/home/dashboard']);

                }

              } else {
                console.error("NO LOGIN");
                console.error(risp);
              }
              this.execLogout = false;
              this.logoChange = false;
            },
            error: (risp: any) => {
              console.error("NO LOGIN");
              console.error(risp);
              this.execLogout = false;
              this.logoChange = false;
              this.microsoftError = true;
            }
          })
        },
        error: (err) => {
          console.error("Error in login");
          console.error(err);
          this.execLogout = false;
          this.logoChange = false;
          this.microsoftError = true;
        },
      });
  }

  logoutPopup() {
    this.MsalService.logoutPopup().pipe(takeUntil(this.theEnd$)).subscribe({
      next: (res: any) => {
        console.warn("LOGOUT RES");
        console.warn(res);
      }
    });
  }
}
